import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { ClassConstructor } from "class-transformer";
import { Objects } from "src/modules/utils/shared/objects";
import { DatabaseUser } from "src/modules/database/shared/database-user.entity";
import { DatabaseUserGroup } from "src/modules/database/shared/database-user-group.model";
import { LoginUserDatabase } from "src/modules/database/shared/login-user-database.model";
import { AuthLoginResult } from "./AuthLoginResult";

export class LoginUser {
    //netgen start
    userName: string;
    loginResult: AuthLoginResult = AuthLoginResult.ok;
    loginResultData: any;
    accessToken: string;
    additional: OrdinaryObject;
    //netgen end

    getAdditional<T extends object>(key: string, type: ClassConstructor<T>): T {
        return this.additional == null ? null : Objects.fromPlainUnsafe(type, this.additional[key]);
    }

    getDatabaseUser(): DatabaseUser {
        return Objects.fromPlainUnsafe(DatabaseUser, this.getAdditional("database", LoginUserDatabase)?.raw);
    }

    getUserGroups(): DatabaseUserGroup[] {
        return this.getDatabaseUser()?.groups;
    }
}
